export default __webpack_public_path__ + "static/media/@karolboing.833f9823.jpg";